import { PencilIcon, TrashIcon } from "@heroicons/react/24/outline";
import { IconButton } from "../../../../../../../components/ui/IconButton";
import { Modal } from "../../../../../../../components/ui/Modal";
import AddCost from "./AddCost";
import DeleteCost from "./DeleteCost";

const Actions = props => {
  const { id, row: fabrication, invoiceId } = props || {};
  const editModalProps = {
    body: AddCost,
    hideCloseButton: true,
    scale: "md",
    fabrication,
    id,
    invoiceId,
  };

  const deleteModalProps = {
    body: DeleteCost,
    description: "Are you sure?",
    hideCloseButton: true,
    scale: "sm",
    closeOnBackdrop: false,
    id,
  };

  if (!id) {
    return null;
  }

  return (
    <div className="user-list-actions flex text-right text-sm font-medium">
      <div className="grid grid-cols-1 sm:grid-cols-2 xl:grid-cols-4 gap-2">
        <Modal {...editModalProps}>
          <IconButton variant="clean" title="Edit Cost">
            <PencilIcon className={`h-4 w-4 cursor-pointer text-gray-400`} />
          </IconButton>
        </Modal>
        <Modal {...deleteModalProps}>
          <IconButton variant="clean" title="Delete Cost">
            <TrashIcon className={`h-4 w-4 cursor-pointer text-gray-400`} />
          </IconButton>
        </Modal>
      </div>
    </div>
  );
};

export default Actions;
